<template>
    <div class="card">
        <h3>Printer Setting</h3>
        <hr>
        <h5>BrowserPrint</h5>
        <div v-if="selected_device">
            <p>
                <span>{{ $t('print_printer_name') }} {{ selected_device['name'] }} ; </span>
                <span>{{ $t('print_printer_device') }} {{ selected_device['deviceType'] }} ; </span>
                <span>{{ $t('print_printer_conn') }} {{ selected_device['connection'] }} ; </span>
            </p>
            <p>
                <span>{{ $t('print_printer_uid') }} {{ selected_device['uid'] }} ; </span>
                <span>{{ $t('print_printer_ver') }} {{ selected_device['version'] }} </span>
            </p>
            <p v-if="browserPrintError" class="error-test">{{ browserPrintError }}</p>
            <p v-if="browserPrintSuccess" style="color: #00d911">{{ browserPrintSuccess }}</p>
            <button class="btn btn-primary" @click="getZpl(0)">Print Test Label</button>
        </div>
        <div v-else>
            <h6>{{ $t('print_error_cannot_find_device') }}</h6>
        </div>

        <hr>
        <h6>{{ $t('common_row_selected') }} {{ printData.length }}</h6>
        <div class="row">
            <div class="col-6"><p>{{ $t('print_select_label') }}</p></div>
            <div class="col-6">
                <select v-model="selectedLabelSize" class="form-select" style="width: fit-content;margin: auto">
<!--     0 -> Test, 1 -> 40x15mm(label1), 2 -> 50x29mm(label2), 3 -> 4x2 inches(label3)-->
                    <option value="label4">{{ $t('print_label_100x80mm') }}</option>
                    <option value="label3">{{ $t('print_label_4x2Inch') }}</option>
                    <option value="label2">{{ $t('print_label_50x29mm') }}</option>
                    <option value="label1">{{ $t('print_label_40x15mm') }}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-6"><p>{{ $t('print_select_print_code') }}</p></div>
            <div class="col-6">
                <select v-model="selectedLabelBarcodeFormat" class="form-select" style="width: fit-content;margin: auto">
                    <option value="out">{{ $t('print_outcode_code') }}</option>
                    <option value="inner">{{ $t('print_innercode_code') }}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-6">{{ $t('print_label_print_amount') }} :</div>
            <div class="col-6">
                <input type="number" v-model="printNumber"
                       style="text-align: center;width: 130px;margin: auto" class="form-control">
            </div>
        </div>

        <div style="width: fit-content;margin: 10px auto 10px auto">
            <button class="btn btn-primary" v-if="printData.length > 0"
                    @click="printAllSelectedLabelNow">
                {{ $t('print_label_print_now') }}
            </button>
            <h5 v-if="printData.length <= 0">{{ $t('print_label_no_selected') }}</h5>
        </div>

    </div>
</template>

<script>

import BrowserPrint from "@/tools/BrowerPrintHelper";

export default {
    name: "PrinterSetting",
    props: {
        printData: {
            type: Array,
            required: true
        }
    },
    data(){
        return{
            selectedLabelSize: '',
            selectedLabelBarcodeFormat: 'out',
            selected_device: '',
            browserPrintError: '',
            browserPrintSuccess: '',
            printNumber: 1,
        }
    },
    mounted() {
        this.readyForLabelPrinting()
        this.selectedLabelSize = "label1"
    },
    methods: {
        async printAllSelectedLabelNow(){
            let data = this.printData
            for(let i=0;i<data.length;i++){
                let this_outCode = data[i]
                await this.$mainApi.get(`api/product?code=${this_outCode}`)
                    .then(response => {
                        if(response.data.status === 80){
                            // 0 -> Test, 1 -> 40x15mm(label1), 2 -> 50x29mm(label2), 3 -> 4x2 inches(label3)
                            let getType = 0
                            switch(this.selectedLabelSize){
                                case "label1":
                                    getType = 1
                                    break
                                case "label2":
                                    getType = 2
                                    break
                                case "label3":
                                    getType = 3
                                    break
                                case "label4":
                                    getType = 4
                                    break
                            }
                            this.getZpl(getType, response.data.details.product[0])
                        }
                    })
            }
        },
        async getZpl(getType, getData){
            await this.$mainApi.get(`api/product/zpl?type=${getType}`)
                .then(response => {
                    if(response.data.status === 80){
                        let zpl = response.data.details.toString()
                        if(getType === 0){
                            this.printNow(zpl)
                        }else{
                            zpl = zpl.replace(/{barcode1}/g,
                                this.selectedLabelBarcodeFormat === 'out' ? getData.outCode : getData.innerCode)
                            zpl = zpl.replace(/{name1}/g, getData.name_en)
                            // \& <= ZPL2 code for -> Next Line
                            zpl = zpl.replace(/{size1}/g, "" + getData.size_detail + "\\&" +
                                getData.in_pack + " " + getData.in_unit1 + "/" + getData.in_unit2)
                            if(Number.isInteger(this.printNumber) === false){
                                this.printNumber = 1
                            }
                            if(this.printNumber <= 0){
                                this.printNumber = 1
                            }
                            for(let ii=0;ii<this.printNumber;ii++){
                                this.printNow(zpl)
                            }
                        }
                    }else{
                        return 0
                    }
                })
        },
        printNow(getZpl) {
            console.log(getZpl)
            this.selected_device.send(getZpl,
                (success) => {
                    console.log("Printing success: " + success)
                    this.browserPrintSuccess = this.$t('common_success')
                },
                (error) => {
                    console.log("Printing Error: " + error)
                    this.browserPrintError = this.$t('print_error_cannot_find_device') + ": " + error
                }
            );
        },
        readyForLabelPrinting(){
            BrowserPrint.getDefaultDevice("printer",
                (device) => {
                    //if default device is found
                    this.selected_device = device;
                },
                (error) => {  //if default device is not found
                    console.log("Connect Error: " + error)
                    this.browserPrintError = this.$t('print_error_cannot_find_device') + ": " + error
                    return false;
                });
        }
    }
}
</script>

<style scoped>

</style>
